// ============================================================================
// LBFORM.JS - Sistema de Formulários AJAX Avançado para WordPress
// ============================================================================
//
// Sistema completo para gerenciamento de formulários AJAX com configurações
// flexíveis através do atributo HTML 'lbform'. Projetado para eficiência
// usando valores 1/0 ao invés de true/false para reduzir o tamanho do HTML.
//
// ÍNDICE DAS SEÇÕES:
// ==================
// 1. SISTEMA DE ÁUDIO E DEBUG     - Configuração de sons e logs de debug
// 2. CONFIGURAÇÕES E MAPEAMENTOS  - Chaves curtas, defaults e mapeamentos
// 3. UTILITÁRIOS DE PARSING       - Funções para processar configurações
// 4. UTILITÁRIOS DE LOADER        - Sistema de loading e manipulação de UI
// 5. PROCESSAMENTO DE MENSAGENS   - Tratamento de toasts e notificações
// 6. EVENT LISTENERS              - Eventos DOM e fluxo principal
// 7. FUNÇÃO PRINCIPAL LBFORM       - Core do processamento AJAX
//
// FUNCIONALIDADES PRINCIPAIS:
// ===========================
// ✓ Configuração via atributo JSON compacto (chaves curtas)
// ✓ Múltiplos tipos de loader (page overlay, inline, target)
// ✓ Sistema de confirmação com lbAlert (mascote)
// ✓ Encadeamento sequencial de formulários
// ✓ Controle granular de áudio e notificações (noToasts/silence)
// ✓ Mensagens padrão de sucesso/erro customizáveis (messageSuccess/messageError)
// ✓ Sistema avançado de animações e transições
// ✓ Animação sequencial de textos de loading com timing configurável
// ✓ Processamento inteligente de mensagens e erros
// ✓ Suporte completo ao WordPress (REST API + admin-ajax)
// ✓ Validação externa e integração com sistemas existentes
//
// DEPENDÊNCIAS EXTERNAS:
// ======================
// - jQuery (obrigatório)
// - SweetAlert2 removido — usa lbAlert (mascote) para confirmações e toasts
// - Bootstrap (opcional, para modais automáticos)
// - Variáveis globais do WordPress: lb_data (assets_url, ajax_url, etc)
// ============================================================================

(function ($) {
	$(document).ready(function () {

		// Tempo extra para exibir a última mensagem do loader antes de processar resposta
		const lastLoadTime = 2000;

		// ============================================================================
		// SEÇÃO 1: SISTEMA DE ÁUDIO E DEBUG
		// ============================================================================
		// Gerencia a reprodução segura de sons de notificação e o sistema de debug
		// condicional baseado na configuração global lb_data.lbdebug

		/**
		 * Reproduz áudio de forma segura com fallback para erros
		 * Usado para feedback sonoro em operações AJAX (sucesso/erro)
		 * @param {Audio} audio - Objeto Audio a ser reproduzido
		 */
		const playSafe = (audio) => {
			if (window.lbSonsMudos?.()) return; // "Silenciar sons" (parts/common/sons.js).
			try {
				// Tenta reproduzir o áudio e captura promise rejections silenciosamente
				audio?.play?.().catch(() => { });
			} catch (_) {
				// Falha silenciosa se áudio não disponível ou navegador não suporta
			}
		};

		/**
		 * Configuração centralizada dos sons do sistema
		 * Cada som tem volume reduzido (0.2) para não ser intrusivo
		 */
		const sounds = {
			success: new Audio(lb_data.assets_url + "audio/success.mp3"),        // AJAX success
			chainSuccess: new Audio(lb_data.assets_url + "audio/finished.mp3"), // Form chain completion
			error: new Audio(lb_data.assets_url + "audio/error.mp3"),            // AJAX error
		};
		// Aplica volume padrão de 20% para todos os sons
		Object.values(sounds).forEach((a) => (a.volume = 0.2));

		/**
		 * Sistema de debug centralizado via lbLog
		 * @param {string} message - Mensagem principal do log
		 * @param {...any} data - Dados adicionais para debug
		 */
		const debug = (message, ...data) => {
			if (window.lbLog) {
				lbLog.form(message, ...data);
			}
		};

		/**
		 * Função global para exibir mensagens usando o sistema lmsg externo
		 * Serve como ponte entre lbform e o sistema de notificações
		 * @param {string} type - Tipo da mensagem (s/d/w/i/f)
		 * @param {string} text - Texto da mensagem
		 */
		const showMessage = (type, text) => {
			if (window.lbAlert) {
				lbAlert.toast({ color: type, html: text, sound: false });
			} else if (lb_data.mascote_alert) {
				var mascoteAlert = window.lbMascote ? lbMascote.molde(type, text) : '';
				$("#lmsg-f").append(mascoteAlert);
			} else {
				$("#lmsg-f").append(
					`<div class="lmsg-item lmsg-${type}">
						${text}
						<div class="lmsg-t"></div><div class="lmsg-c"></div>
					</div>`
				);
			}
		};

		// ============================================================================
		// SEÇÃO 2: CONFIGURAÇÕES E MAPEAMENTOS
		// ============================================================================
		// Define o sistema de chaves curtas para economizar espaço no HTML e
		// centraliza todas as configurações padrão do sistema lbform

		/**
		 * Mapa de aliases curtos para chaves completas do atributo lbform
		 * Permite usar 'w' em vez de 'wpAjax' no HTML para economizar bytes
		 * Organizadas por categoria: request, UI, confirmação e response
		 */
		const KEYMAP = {
			// === CONFIGURAÇÕES DE REQUEST ===
			w: "wpAjax",                    // Usar admin-ajax.php vs REST API
			ai: "additionalInputs",         // Seletor de inputs externos ao form

			// === CONFIGURAÇÕES DE UI/LOADER ===
			t: "target",                    // Seletor CSS onde inserir resposta
			l: "load",                      // Tipo de loader (page/inline/target)
			lt: "loadText",                 // Texto ou array de textos do loader
			ltt: "loadTextTiming",          // Timing da animação de texto (ms)

			// === CONFIGURAÇÕES DE COMPORTAMENTO ===
			r: "redirect",                  // URL para redirecionamento
			rf: "refresh",                  // Recarregar página após sucesso
			rfh: "refresh_htmx",            // Partial reload via htmx (gestao)
			di: "disableInputsOnSubmit",    // Desabilitar inputs durante AJAX
			re: "removeOnEmpty",            // Remover target se resposta vazia
			df: "disableModeFocus",         // Remover data-layout="lb-focus"
			bf: "blockOthersForms",         // Seletor de outros forms a bloquear
			cm: "closeModal",               // Fechar modais após sucesso			// === CONFIGURAÇÕES DE CHAIN ===
			nf: "nextForm",                 // Próximo formulário na sequência
			ilf: "isLastForm",              // Mensagem final da cadeia

			// === CONFIGURAÇÕES DE CONFIRMAÇÃO ===
			c: "confirm",                   // Ativar popup de confirmação
			ct: "confirmTitle",             // Título do popup
			cx: "confirmText",              // Texto do popup
			cc: "confirmClass",             // Classes adicionais CSS do popup
			cco: "confirmColor",            // Cor do popup (red/green/blue/yellow/purple/orange/gray/warning/info/success/danger)
			ci: "confirmIcon",              // Ícone do popup (warning/info/etc)
			cbt: "confirmButtonText",       // Texto do botão de confirmação
			csc: "confirmShowCancelButton", // Exibir botão de cancelar
			cct: "confirmCancelButtonText", // Texto do botão de cancelar

			// === CONFIGURAÇÕES DE NOTIFICAÇÃO (NOVAS) ===
			nt: "noToasts",                 // Remover toasts da resposta HTML
			s: "silence",                   // Desabilitar sons de notificação
			ms: "messageSuccess",           // Mensagem padrão de sucesso
			me: "messageError",             // Mensagem padrão de erro

			// === CONFIGURAÇÕES ESPECIAIS ===
			lfn: "lbformNew",               // Atualizações permanentes do atributo			// === CONFIGURAÇÕES DE RESPONSE (apenas resposta do servidor) ===
			nu: "newUrl",                   // Nova URL para history.replaceState
			nut: "newUrlTitle",             // Novo título da página
		};

		/**
		 * Mapa reverso para conversão de chaves completas -> aliases curtos
		 * Gerado automaticamente a partir do KEYMAP para manter consistência
		 * Usado ao escrever configurações de volta para o atributo HTML
		 */
		const REVMAP = (() => {
			const reverseMap = {};
			Object.keys(KEYMAP).forEach((shortKey) => {
				const longKey = KEYMAP[shortKey];
				reverseMap[longKey] = shortKey;
			});
			return reverseMap;
		})();

		/**
		 * Configurações padrão do sistema lbform
		 * IMPORTANTE: Usa 1/0 para booleans para economizar espaço no HTML
		 * Todas as configurações podem ser sobrescritas via atributo lbform
		 */
		const defaultFormConfigs = {
			// === CONFIGURAÇÕES DE REQUEST ===
			wpAjax: 0,                              // 0 = REST API, 1 = admin-ajax.php
			additionalInputs: "",                   // Seletor jQuery de inputs externos

			// === CONFIGURAÇÕES DE UI/LOADER ===
			target: "",                             // Seletor onde inserir resposta (vazio = auto)
			load: "inline",                         // Tipo: "page" | "inline" | "target"
			loadText: "",                           // Texto fixo ou array para rotação sequencial
			loadTextTiming: 2000,                   // Duração de cada texto (ms) ou array de durações

			// === CONFIGURAÇÕES DE COMPORTAMENTO ===
			redirect: "",                           // URL para redirecionamento pós-sucesso
			refresh: 0,                             // 1 = recarrega a página atual
			refresh_htmx: 0,                        // 1 = partial reload via htmx (gestao)
			disableInputsOnSubmit: 1,               // 1 = desabilita inputs durante AJAX
			removeOnEmpty: 0,                       // 1 = remove target se resposta vazia
			disableModeFocus: 1,                    // 1 = remove layout focus do body
			blockOthersForms: "",                   // Seletor de forms para bloquear
			closeModal: 0,                          // 1 = fecha modais (Bootstrap + lb-popup) após sucesso			// === CONFIGURAÇÕES DE CHAIN (SEQUÊNCIA) ===
			nextForm: "",                           // Seletor do próximo form na cadeia
			isLastForm: "",                         // Mensagem exibida ao final da cadeia

			// === CONFIGURAÇÕES DE CONFIRMAÇÃO ===
			confirm: 0,                             // 1 = ativa popup de confirmação
			confirmTitle: "Você tem certeza?",      // Título do popup
			confirmText: "Você tem certeza que deseja continuar?", // Mensagem
			confirmClass: "",                       // Classes adicionais CSS para o container do SweetAlert2
			confirmColor: "",                       // Cor do popup: red/green/blue/yellow/purple/orange/gray/warning/info/success/danger
			confirmIcon: "warning",                 // Ícone: warning/info/success/error/question
			confirmButtonText: "Confirmar",         // Texto do botão principal
			confirmShowCancelButton: 1,             // 1 = exibe botão de cancelar
			confirmCancelButtonText: "Cancelar",    // Texto do botão de cancelar


			// === CONFIGURAÇÕES DE NOTIFICAÇÃO (NOVAS FUNCIONALIDADES) ===
			noToasts: 0,                            // 1 = remove toasts do HTML de resposta
			silence: 0,                             // 1 = desabilita sons de sucesso/erro
			messageSuccess: "Enviado com sucesso",  // Mensagem padrão de sucesso
			messageError: "Houve um erro, atualize a página e tente novamente", // Mensagem padrão de erro

			// === CONFIGURAÇÕES ESPECIAIS ===
			lbformNew: "",                          // JSON para atualizar permanentemente o atributo
		};
		// ============================================================================
		// SEÇÃO 3: UTILITÁRIOS DE PARSING E CONFIGURAÇÃO
		// ============================================================================
		// Conjunto de funções para processar, normalizar e combinar configurações
		// vindas do atributo HTML lbform com os valores padrão do sistema

		/**
		 * Expande chaves curtas de um objeto para suas versões completas
		 * Exemplo: {w: 1, t: "#result"} -> {wpAjax: 1, target: "#result"}
		 * @param {Object} obj - Objeto com chaves curtas
		 * @returns {Object} - Objeto com chaves expandidas
		 */
		const expandShortKeys = (obj) => {
			if (!obj || typeof obj !== "object") return {};
			const expanded = {};
			Object.keys(obj).forEach((shortKey) => {
				// Usa KEYMAP para expandir, ou mantém a chave original se não encontrar
				const longKey = KEYMAP[shortKey] || shortKey;
				expanded[longKey] = obj[shortKey];
			});
			return expanded;
		};

		/**
		 * Normaliza valores para boolean, lidando com diferentes formatos
		 * Converte 1/0, "true"/"false", "on"/"off", etc. para boolean real
		 * @param {any} value - Valor a ser normalizado
		 * @returns {boolean} - Valor boolean normalizado
		 */
		const normalizeBoolean = (value) => {
			// Se já é number, 1 = true, qualquer outro = false
			if (typeof value === 'number') return value === 1;
			// Se já é boolean, mantém
			if (typeof value === 'boolean') return value;
			// Se é string, normaliza valores comuns
			if (typeof value === 'string') {
				const normalized = value.toLowerCase().trim();
				return ['1', 'true', 'on', 'yes'].includes(normalized);
			}
			// Para outros tipos, usa conversão padrão do JS
			return Boolean(value);
		};

		/**
		 * Tenta fazer parse de JSON com tratamento seguro de erros
		 * Evita quebrar o sistema se o JSON estiver malformado
		 * @param {string} jsonString - String JSON para parsear
		 * @param {any} fallback - Valor retornado em caso de erro
		 * @returns {any} - Objeto parseado ou fallback
		 */
		const tryParseJSON = (jsonString, fallback = {}) => {
			// Se não é string, retorna o valor se for objeto ou o fallback
			if (typeof jsonString !== "string") {
				return jsonString && typeof jsonString === "object" ? jsonString : fallback;
			}
			try {
				return JSON.parse(jsonString);
			} catch (error) {
				debug("Erro ao parsear JSON do atributo lbform:", error, jsonString);
				return fallback;
			}
		};

		/**
		 * Lê e processa o atributo lbform de um elemento form
		 * Faz o parse do JSON e expande as chaves curtas
		 * Prioriza input[name="lbform"] sobre o atributo lbform
		 * @param {HTMLFormElement} formElement - Elemento form do DOM
		 * @returns {Object} - Configurações expandidas do atributo ou input
		 */
		const readLbFormAttr = (formElement) => {
			const $form = $(formElement);

			// Verifica se existe input[name="lbform"] dentro do form (prioridade)
			const $lbformInput = $form.find('input[name="lbform"]');

			if ($lbformInput.length > 0) {
				const inputValue = $lbformInput.val();
				const parsedJSON = inputValue ? tryParseJSON(inputValue, {}) : {};
				return expandShortKeys(parsedJSON);
			}

			// Fallback para atributo lbform se input não existir
			const rawAttr = $form.attr("lbform");
			const parsedJSON = rawAttr ? tryParseJSON(rawAttr, {}) : {};
			return expandShortKeys(parsedJSON);
		};		/**
		 * Combina configurações padrão com as do atributo lbform
		 * Aplica normalização de tipos e validação de chaves
		 * @param {HTMLFormElement} formElement - Elemento form do DOM
		 * @returns {Object} - Configurações finais mescladas e normalizadas
		 */
		const getConfigs = (formElement) => {
			const attrConfigs = readLbFormAttr(formElement);
			const finalConfigs = { ...defaultFormConfigs };

			// Aplica configurações do atributo, com normalização de tipos
			Object.keys(attrConfigs).forEach(configKey => {
				if (configKey in finalConfigs) {
					const attrValue = attrConfigs[configKey];
					const defaultValue = finalConfigs[configKey];

					// Se o padrão é boolean ou binary (0/1), normaliza o valor
					if (typeof defaultValue === 'boolean' ||
						(typeof defaultValue === 'number' && (defaultValue === 0 || defaultValue === 1))) {
						finalConfigs[configKey] = normalizeBoolean(attrValue);
					} else {
						// Para outros tipos, usa o valor diretamente
						finalConfigs[configKey] = attrValue;
					}
				}
			});

			return finalConfigs;
		};

		// ============================================================================
		// SEÇÃO 4: UTILITÁRIOS DE LOADER E MANIPULAÇÃO
		// ============================================================================

		// Tamanho do alvo (para loaders que substituem o target)
		const getTargetSize = (target) => {
			const $t = $(target);
			const h = Math.max(($t.height() || 0), 50);
			const w = Math.max(($t.width() || 0), 50);
			return { h, w };
		};

		// Constrói HTML do loader conforme modo
		const buildLoader = (mode, loadText, size) => {

			const img = lb_data.assets_url + "img/load/load" + (Math.floor(Math.random() * lb_data.load_count) + 1) + ".gif";

			// Processa loadText (pode ser string, array ou undefined)
			let textContent = "";
			let animatedText = false;

			if (Array.isArray(loadText)) {
				// loadText é array: exibe primeiro item e configura animação
				animatedText = true;
				textContent = loadText.length > 0 ? loadText[0] : "Carregando...";
			} else if (typeof loadText === "string" && loadText.trim() !== "") {
				// loadText é string não vazia
				textContent = loadText;
			} else {
				// loadText vazio/undefined: usa padrão para todos os modos
				textContent = "Carregando...";
			}

			// Escapar texto
			const safeText = textContent ? $('<div>').text(textContent).html() : "";

			if (mode === "inline") {
				const text = safeText ? `<span class="lbf-text">${safeText}</span>` : "";
				const loader = `<div class="lbf-load-inline" data-animated="${animatedText}"><img src="${img}" alt="" />${text}</div>`;
				return loader;
			}

			// Modos target/page: o carregando único com a mascote (lb-carregando.js; 'mascote' porque
			// o envio é disparado pela pessoa com a tela já aberta — a imagem já veio, decisão 18/10/2026).
			// A frase fica em .lb-carr-t — o startTextAnimation também a encontra.
			const carregando = window.lbCarregando ? window.lbCarregando.html("mascote", textContent) : "";

			if (mode === "target") {
				const h = size?.h ? ` style="min-height:${size.h}px"` : "";
				const text = safeText ? `<div class="lbf-load-text">${safeText}</div>` : "";
				const loader = carregando
					? `<div class="lbf-load-target" data-animated="${animatedText}"${h}>${carregando}</div>`
					: `<div class="lbf-load-target" data-animated="${animatedText}"${h}><img src="${img}" alt="" />${text}</div>`;
				return loader;
			}

			// page overlay
			const text = safeText ? `<div class="lbf-load-text">${safeText}</div>` : "";
			const loader = carregando
				? `<div class="lbf-load-overlay" data-animated="${animatedText}"><div class="lbf-load-content">${carregando}</div></div>`
				: `<div class="lbf-load-overlay" data-animated="${animatedText}"><div class="lbf-load-content"><img src="${img}" alt="" />${text}</div></div>`;
			return loader;
		};

		// Inicia animação de texto sequencial para loadText array
		// Para na penúltima mensagem, depois exibe a última por 2s antes de finalizar
		// timing pode ser número único ou array de durações individuais
		const startTextAnimation = (loaderEl, loadTextArray, timing = 2000, formElement = null) => {
			if (!Array.isArray(loadTextArray) || loadTextArray.length <= 1) return;

			const $loader = $(loaderEl);
			const $textEl = $loader.find('.lbf-text, .lbf-load-text, .lb-carr-t');

			if (!$textEl.length) return;

			let currentIndex = 0;
			const totalTexts = loadTextArray.length;

			// Array para armazenar IDs de timers para limpeza posterior
			const timerIds = [];

			// Determina timing para cada texto
			// Se timing é array: usa valores específicos para cada posição
			// Se timing é número: aplica mesmo valor para todas as posições
			let intervals = [];
			if (Array.isArray(timing)) {
				intervals = timing.slice(0, totalTexts);
				// Preenche com último valor se timing array for menor que número de textos
				while (intervals.length < totalTexts) {
					intervals.push(timing[timing.length - 1] || 1000);
				}
			} else {
				intervals = new Array(totalTexts).fill(timing || 1000);
			}

			const animateNext = () => {
				currentIndex++;

				// Para na penúltima mensagem (antes da última)
				if (currentIndex >= totalTexts - 1) return;

				const nextText = $('<div>').text(loadTextArray[currentIndex]).html();

				$textEl.fadeOut(200, function () {
					$(this).html(nextText).fadeIn(200);
				});

				const timerId = setTimeout(animateNext, intervals[currentIndex]);
				timerIds.push(timerId);

				// Armazena timer IDs no formulário se fornecido
				if (formElement) {
					const $form = $(formElement);
					const existingTimers = $form.data('lbform-animation-timers') || [];
					existingTimers.push(timerId);
					$form.data('lbform-animation-timers', existingTimers);
				}
			};

			// Função para exibir última mensagem antes de finalizar
			const showFinalText = () => {
				if (totalTexts > 1) {
					const finalText = $('<div>').text(loadTextArray[totalTexts - 1]).html();
					$textEl.fadeOut(200, function () {
						$(this).html(finalText).fadeIn(200);
					});

					// Aguarda o tempo definido em lastLoadTime antes de sinalizar conclusão
					const finalTimerId = setTimeout(() => {
						// Adiciona classe especial para indicar que animação terminou
						$loader.addClass('lbf-animation-complete');
					}, lastLoadTime);

					timerIds.push(finalTimerId);

					// Armazena timer IDs no formulário se fornecido
					if (formElement) {
						const $form = $(formElement);
						const existingTimers = $form.data('lbform-animation-timers') || [];
						existingTimers.push(finalTimerId);
						$form.data('lbform-animation-timers', existingTimers);
					}
				}
			};

			// Armazena referência da função final no elemento para acesso externo
			$loader.data('showFinalText', showFinalText);

			// Armazena função de cancelamento no loader
			$loader.data('cancelAnimation', () => {
				timerIds.forEach(timerId => clearTimeout(timerId));
				timerIds.length = 0;
			});

			// Inicia após primeiro intervalo
			const firstTimerId = setTimeout(animateNext, intervals[0]);
			timerIds.push(firstTimerId);

			// Armazena timer IDs no formulário se fornecido
			if (formElement) {
				const $form = $(formElement);
				const existingTimers = $form.data('lbform-animation-timers') || [];
				existingTimers.push(firstTimerId);
				$form.data('lbform-animation-timers', existingTimers);
			}
		};

		// Encontra o melhor container para inserir conteúdo sem target
		const findBestContainer = () => {
			const selectors = ['#lb_body', '.page-content', '.site-content', 'body'];
			for (const selector of selectors) {
				const $container = $(selector);
				if ($container.length > 0) return $container;
			}
			return $('body');
		};

		// Aplica redirecionamento ou refresh, com splash simples
		const applyRedirectOrRefresh = (redirect, refresh, refreshHtmx) => {
			if (!redirect && !refresh && !refreshHtmx) return false;
			if (refreshHtmx && window.htmx) {
				htmx.ajax('GET', window.location.href, { target: '#lb_body', swap: 'innerHTML show:window:top' });
				return true;
			}
			const img = lb_data.assets_url + "img/load/load1.gif";
			$("body").append(`<div class="lbf-load-overlay"><img src="${img}" /></div>`);
			if (redirect) window.location.href = redirect;
			else if (refresh) location.reload();
			return true;
		};

		// Atualiza URL/título sem reload
		const updateHistory = (newUrl, newUrlTitle) => {
			if (newUrl) {
				history.replaceState({ page: 1 }, newUrlTitle || document.title, newUrl);
			} else if (newUrlTitle) {
				history.replaceState({ page: 1 }, newUrlTitle, window.location.href);
			}
		};

		/**
		 * Remove escape de caracteres JSON de uma string HTML
		 * Converte \/, \n, \t, \uXXXX etc. para seus caracteres originais
		 * @param {string} str - String com caracteres escapados
		 * @returns {string} - String com caracteres decodificados
		 */
		const unescapeJsonString = (str) => {
			if (typeof str !== 'string') return str;

			return str
				.replace(/\\"/g, '"')      // \" -> "
				.replace(/\\\//g, '/')     // \/ -> /
				.replace(/\\n/g, '\n')     // \n -> quebra de linha
				.replace(/\\t/g, '\t')     // \t -> tab
				.replace(/\\r/g, '\r')     // \r -> carriage return
				.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
					// \uXXXX -> caractere Unicode correspondente
					return String.fromCharCode(parseInt(hex, 16));
				})
				.replace(/\\\\/g, '\\');   // \\ -> \ (deve ser último)
		};

		/**
		 * Extrai HTML da resposta com detecção automática do tipo
		 * Detecta automaticamente se a resposta é JSON ou HTML puro
		 * Não depende mais do parâmetro dataType configurado
		 * Trata "0" como resposta inválida (erro comum do WordPress)
		 * @param {any} response - Resposta do servidor (string ou objeto)
		 * @returns {string} - HTML extraído da resposta
		 */
		const extractHtml = (response) => {
			let html = "";
			let source = "unknown";

			if (response && typeof response === "object") {
				// Resposta é objeto JSON, procura por propriedades de HTML
				html = response?.html ?? response?.data?.html ?? "";
				source = response?.html ? 'json-direct' : response?.data?.html ? 'json-nested' : 'json-empty';

			} else if (typeof response === "string") {

				// Verifica se a resposta é apenas "0" (erro comum do WordPress)
				const trimmedResponse = response.trim();
				if (trimmedResponse === "0") return "";

				// Resposta é string direta (HTML puro ou texto)
				// Verifica se parece ser JSON string escapada
				if (response.includes('\\/') || response.includes('\\n') || response.includes('\\t') || response.includes('\\u')) {
					html = unescapeJsonString(response);
					source = "html-string-unescaped";
				} else {
					html = response;
					source = "html-string";
				}

				// Remove aspas duplas no início e fim se existirem (string JSON bruta)
				if (html.length >= 2 && html.startsWith('"') && html.endsWith('"')) {
					html = html.slice(1, -1);
					source += "-quoted";
				}
			} else {
				// Tipo inesperado, tenta conversão para string
				html = String(response || "");
				source = "fallback-string";
			}

			return html;
		};
		// Mescla configs vindas da resposta sobrepondo as do form
		const getResponseConfigs = (responseLbform, formConfigs) => {
			const defaults = {
				redirect: "",
				refresh: 0,
				removeOnEmpty: 0,
				disableModeFocus: 1,
				nextForm: "",
				isLastForm: "",
				noToasts: 0,
				silence: 0,
				lbformNew: "",
				// Especifico para resposta
				newUrl: "",
				newUrlTitle: "",
				replace: {},// old lbreplace
			};
			const expanded = expandShortKeys(tryParseJSON(responseLbform || {}, {}));
			const merged = { ...defaults, ...formConfigs, ...expanded };

			// Normaliza valores boolean da resposta
			Object.keys(expanded).forEach(key => {
				if (key in merged && typeof defaults[key] === 'number' && (defaults[key] === 0 || defaults[key] === 1)) {
					merged[key] = normalizeBoolean(expanded[key]);
				}
			});

			return merged;
		};

		// Atualiza atributo lbform do próprio form (quando backend retorna lbformNew)
		const maybeUpdateFormAttr = (form, lbformNew) => {
			if (!$(form).length || !lbformNew) return;

			// Permite que backend envie { lbformNew: "{...}" } ou objeto direto
			let src = lbformNew;
			if (src && typeof src === "object" && Object.keys(src).length === 1 && Object.prototype.hasOwnProperty.call(src, "lbformNew")) {
				src = src.lbformNew;
			}
			if (typeof src === "string") src = tryParseJSON(src, {});
			if (!src || typeof src !== "object") return;

			// Expande chaves curtas para longas e remove iguais ao default
			const expanded = expandShortKeys(src);
			const pruned = {};
			Object.keys(expanded).forEach((k) => {
				if (k === "lbformNew") return; // nunca persistir essas chaves no atributo
				if (Object.prototype.hasOwnProperty.call(defaultFormConfigs, k)) {
					const normalizedValue = typeof defaultFormConfigs[k] === 'boolean' || (typeof defaultFormConfigs[k] === 'number' && (defaultFormConfigs[k] === 0 || defaultFormConfigs[k] === 1))
						? normalizeBoolean(expanded[k])
						: expanded[k];
					if (normalizedValue !== defaultFormConfigs[k]) {
						// Converte boolean para 1/0 para economia de espaço
						pruned[k] = typeof normalizedValue === 'boolean' ? (normalizedValue ? 1 : 0) : normalizedValue;
					}
				}
			});

			// Converte para chaves curtas
			const minimized = {};
			Object.keys(pruned).forEach((k) => {
				const shortKey = REVMAP[k] || k;
				minimized[shortKey] = pruned[k];
			});

			// Escreve no atributo (objeto vazio -> "{}" limpa para apenas defaults)
			try {
				$(form).attr("lbform", JSON.stringify(minimized));
			} catch (_) {
				$(form).attr("lbform", "{}");
			}
		};

		// Desabilita/habilita inputs do form
		// Preserva campos que já estavam disabled antes do submit
		const toggleFormInputs = (form, disabled) => {
			const $form = $(form);
			const $inputs = $form.find(":input");

			if (disabled) {
				// Ao desabilitar: salva quais já estavam disabled
				$inputs.each(function () {
					const $input = $(this);
					if ($input.prop('disabled')) {
						$input.data('was-disabled', true);
					}
					$input.prop('disabled', true);
				});
			} else {
				// Ao habilitar: restaura apenas os que não estavam disabled originalmente
				$inputs.each(function () {
					const $input = $(this);
					if (!$input.data('was-disabled')) {
						$input.prop('disabled', false);
					}
				});
			}
		};

		// Bloqueia/desbloqueia outros forms
		const toggleOtherForms = (selector, disabled) => {
			if (!selector) return;
			$(selector).toggleClass("lb-disabled", !!disabled);
		};

		/**
		 * Inclui inputs adicionais externos ao formulário no FormData
		 * Permite capturar inputs que estão fora do form mas devem ser enviados
		 * @param {FormData} formData - Objeto FormData a ser populado
		 * @param {HTMLFormElement} form - Formulário principal (para exclusão)
		 * @param {string} selector - Seletor jQuery dos inputs externos
		 */
		const appendAdditionalInputs = (formData, form, selector) => {
			if (!selector) return;

			const $formScope = $(form);

			$("body")
				.find(selector)
				.not($formScope.find(selector)) // Exclui inputs que já estão no form
				.each(function () {
					const $input = $(this);
					const inputName = $input.attr("name");
					if (!inputName) return; // Ignora inputs sem name

					const inputType = ($input.attr("type") || "").toLowerCase();

					// Lida com diferentes tipos de input
					if (inputType === "checkbox" || inputType === "radio") {
						if ($input.prop("checked")) {
							formData.append(inputName, $input.val());
						}
					} else if (this.tagName === "SELECT" && this.multiple) {
						// Select múltiplo: adiciona cada valor selecionado
						($input.val() || []).forEach((value) => {
							formData.append(inputName, value);
						});
					} else if (inputType === "file" && this.files) {
						// Input file: adiciona cada arquivo
						for (let i = 0; i < this.files.length; i++) {
							formData.append(inputName, this.files[i]);
						}
					} else {
						// Input normal: adiciona o valor
						formData.append(inputName, $input.val());
					}
				});
		};

		/**
		 * Restaura loader e conteúdo original de um target
		 * Centraliza a lógica repetitiva de cleanup do loader
		 * @param {jQuery} $loaderEl - Elemento loader a ser removido
		 * @param {jQuery} $target - Target container
		 * @param {Object} originalContent - Conteúdo original salvo
		 * @param {Function} callback - Função a executar após restauração
		 */
		const restoreTargetContent = ($loaderEl, $target, originalContent, callback = null) => {
			if (!$loaderEl || !$target) return;

			// Cancela animações antes de remover
			const cancelAnimation = $loaderEl.data('cancelAnimation');
			if (cancelAnimation && typeof cancelAnimation === 'function') cancelAnimation();

			$loaderEl.fadeOut(200, function () {

				// Remove dados anexados ao loader antes de remover do DOM
				$loaderEl.removeData('showFinalText');
				$loaderEl.removeData('cancelAnimation');

				$loaderEl.remove();

				// Restaura posição CSS original se foi alterada
				if (originalContent && originalContent.position === 'static') {
					$target.css('position', '');
				}

				// Executa callback personalizado se fornecido
				if (callback && typeof callback === 'function') callback();
			});
		};

		/**
		 * Initialize libraries and Alpine in dynamically inserted content.
		 * Called after inserting HTML via AJAX response.
		 *
		 * @param {HTMLElement|jQuery} container - Container with new content
		 */
		const initDynamicContent = (container) => {
			const el = container instanceof jQuery ? container[0] : container;
			if (!el) return;

			// Initialize Alpine trees if Alpine is available
			if (window.Alpine) {
				window.Alpine.initTree(el);
			}

			// Initialize libs via lib-loader (gestao) or legacy lbLoadPlugins (gestao1/front)
			if (window.lbLibs && typeof window.lbLibs.initDom === 'function') {
				window.lbLibs.initDom(el);
			} else if (typeof jQuery !== 'undefined') {
				// Legacy fallback for gestao1/front
				jQuery(document).trigger('lbContentLoaded', [el]);
			}
		};

		// ============================================================================
		// SEÇÃO 5: PROCESSAMENTO DE MENSAGENS E NOTIFICAÇÕES
		// ============================================================================
		// Sistema para extrair, processar e exibir mensagens vindas do servidor
		// tanto em HTML embarcado quanto em objetos JSON de resposta

		/**
		 * Processa todas as mensagens encontradas na resposta AJAX
		 * Extrai mensagens de elementos HTML (.lmsg-*) e do objeto response
		 * Remove elementos de mensagem do DOM para evitar duplicação
		 * 
		 * @param {jQuery} $html - Objeto jQuery contendo HTML da resposta
		 * @param {Object} response - Objeto de resposta do AJAX
		 * @param {boolean} isSuccess - Se a requisição foi bem-sucedida
		 * @return {number} - Total de mensagens processadas
		 */
		function handleMessagesHtml($html, response, isSuccess) {
			// Procura por elementos com classes específicas de mensagem
			const $messages = $html.find('.lmsg-f');

			// Se houver mensagens fixas, move para container principal
			if ($messages.length) {
				// Recupera HTML bruto das mensagens
				let messagesHtml = "";
				$messages.each(function () {
					messagesHtml += $(this).html();
					$(this).remove();
				});

				// Move mensagens fixas para o container principal
				$("#lmsg-f").append(messagesHtml);
			}

			return $messages.length;
		}

		/**
		 * Processa mensagens JSON simples do response
		 * Extrai mensagens de diferentes formatos e exibe via showMessage
		 * 
		 * Suporta:
		 * - response.message (string)
		 * - response.data (string ou objeto com message)
		 * - response.data.messages (array de strings)
		 * - response.messages (array de strings)
		 *
		 * @param {Object} response - Objeto de resposta AJAX
		 * @param {boolean} isSuccess - Se a requisição foi bem-sucedida
		 * @returns {number} - Quantidade de mensagens processadas
		 */
		function handleMessagesJson(response, isSuccess = true) {
			let messagesCount = 0;
			const msgType = isSuccess ? 's' : 'd';

			// Mensagem direta no response
			if (response.message && typeof response.message === 'string' && response.message.trim()) {
				showMessage(msgType, response.message);
				messagesCount++;
			}

			// Mensagens em data
			if (response.data) {
				if (typeof response.data === 'string' && response.data.trim()) {
					showMessage(msgType, response.data);
					messagesCount++;
				} else if (response.data.message && typeof response.data.message === 'string' && response.data.message.trim()) {
					showMessage(msgType, response.data.message);
					messagesCount++;
				}

				// Array de mensagens em data.messages
				if (Array.isArray(response.data.messages)) {
					response.data.messages.forEach(msg => {
						if (typeof msg === 'string' && msg.trim()) {
							showMessage(msgType, msg);
							messagesCount++;
						}
					});
				}
			}

			// Array de mensagens no nível raiz
			if (Array.isArray(response.messages)) {
				response.messages.forEach(msg => {
					if (typeof msg === 'string' && msg.trim()) {
						showMessage(msgType, msg);
						messagesCount++;
					}
				});
			}

			return messagesCount;
		}

		// Detecta se a resposta é JSON válida
		// Aceita jqXHR, string, array ou objeto simples
		// Rejeita números, booleanos, null, undefined, funções, etc.
		// Baseado em heurísticas: Content-Type, responseJSON, parse do responseText
		function isJsonResponse(input) {
			// Se for jqXHR, trate adequadamente
			if (input && typeof input === 'object' && typeof input.getResponseHeader === 'function') {
				// 1) jQuery pode preencher responseJSON mesmo com status 4xx/5xx
				if (input.responseJSON !== undefined) return true;

				// 2) Verifique Content-Type
				var ct = input.getResponseHeader('Content-Type') || '';
				if (ct.indexOf('application/json') !== -1 || ct.indexOf('+json') !== -1) {
					// tenta parsear se houver texto
					if (typeof input.responseText === 'string') {
						try { JSON.parse(input.responseText); return true; } catch (e) { return false; }
					}
					return true; // sem texto mas cabeçalho diz JSON
				}

				// 3) Último recurso: tente parsear o responseText
				if (typeof input.responseText === 'string') {
					try { JSON.parse(input.responseText); return true; } catch (e) { return false; }
				}
				return false;
			}

			// Se não for jqXHR: aceite apenas string, array ou objeto "simples"
			if (typeof input === 'string') {
				try { JSON.parse(input); return true; } catch (e) { return false; }
			}
			if (Array.isArray(input)) return true;
			if (window.jQuery && jQuery.isPlainObject && jQuery.isPlainObject(input)) return true;

			return false;
		}

		// Processa substituições de conteúdo
		function replace(replaceConfig) {
			if (!replaceConfig || typeof replaceConfig !== 'object') return;

			Object.keys(replaceConfig).forEach(selector => {
				const content = replaceConfig[selector];
				const $target = $(selector);

				if ($target.length > 0 && content !== undefined) {
					if (content === "" || content === null) {
						// Remove elemento
						$target.fadeOut(300, function () {
							$target.remove();
						});
					} else {
						// Substitui conteúdo
						const $newContent = $(content).hide();
						$target.fadeOut(200, function () {
							$target.html($newContent.html());
							initDynamicContent($target);
							$target.fadeIn(300);
						});
					}
				}
			});
		}

		// Abre modais baseados em classe
		function openAjaxModals() {
			setTimeout(() => {
				// Bootstrap modals
				const $modals = $('.lb-modal-auto, .modal.auto-open').not('.show');
				$modals.each(function () {
					const $modal = $(this);
					if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
						const modal = new bootstrap.Modal($modal[0]);
						modal.show();
					} else if ($modal.modal) {
						$modal.modal('show');
					}
				});

				// lb-popup modals
				const $popups = $('[data-lb-popup].auto-open, [data-lb-popup].lb-modal-auto').not('.is-open');
				$popups.each(function () {
					const $popup = $(this);
					$popup.addClass('is-open').removeAttr('aria-hidden');
					if (typeof window.lbPopup !== 'undefined' && window.lbPopup.open) {
						window.lbPopup.open($popup[0]);
					}
				});
			}, 500);
		}

		// Fecha todos os modais (Bootstrap e lb-popup)
		function closeAllModals() {
			// Fecha modais Bootstrap
			const $bootstrapModals = $('.modal.show');
			$bootstrapModals.each(function () {
				const $modal = $(this);
				if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
					const modalInstance = bootstrap.Modal.getInstance($modal[0]);
					if (modalInstance) modalInstance.hide();
				} else if ($modal.modal) {
					$modal.modal('hide');
				}
			});

			// Fecha lb-popup modals
			const $popups = $('[data-lb-popup].is-open');
			$popups.each(function () {
				const $popup = $(this);
				if (typeof window.lbPopup !== 'undefined' && window.lbPopup.close) {
					window.lbPopup.close($popup[0]);
				} else {
					$popup.removeClass('is-open').attr('aria-hidden', 'true');
				}
			});
		}
		// Restaura estado do form após AJAX
		function restoreForm(form) {
			const $form = $(form);
			const cfg = getConfigs(form);
			if (cfg.disableInputsOnSubmit) toggleFormInputs(form, false);

			// Remove classes de validação
			$form.removeClass('was-validated');
			$form.find('.is-invalid, .is-valid').removeClass('is-invalid is-valid');
		}

		/**
		 * Tenta exibir elementos inválidos que estejam escondidos
		 * Percorre campos inválidos e tenta torná-los visíveis
		 * abrindo abas, accordions, modais ou removendo display:none
		 * 
		 * @param {HTMLFormElement} form - Formulário com campos inválidos
		 */
		function showInvalidHiddenElements(form) {
			const $form = $(form);

			// Encontra o primeiro campo inválido
			const $invalidInputs = $form.find(':invalid').filter(':input');
			if ($invalidInputs.length === 0) return;

			const $firstInvalid = $invalidInputs.first();

			// Verifica se o campo está visível
			if ($firstInvalid.is(':visible')) {
				$firstInvalid.trigger('focus');
				return;
			}

			// Tenta diferentes estratégias para exibir o elemento

			// 1. Procura por tabs Bootstrap (abas)
			const $tabPane = $firstInvalid.closest('.tab-pane');
			if ($tabPane.length) {
				const tabId = $tabPane.attr('id');
				const $tabButton = $(`[data-bs-toggle="tab"][href="#${tabId}"], [data-bs-toggle="tab"][data-bs-target="#${tabId}"]`);

				if ($tabButton.length) {
					if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
						const tab = new bootstrap.Tab($tabButton[0]);
						tab.show();
					} else {
						$tabButton.tab('show');
					}

					// Aguarda transição da aba antes de focar
					setTimeout(() => $firstInvalid.trigger('focus'), 350);
					return;
				}
			}

			// 2. Procura por accordion Bootstrap
			const $collapse = $firstInvalid.closest('.collapse');
			if ($collapse.length && !$collapse.hasClass('show')) {
				const collapseId = $collapse.attr('id');
				const $collapseButton = $(`[data-bs-toggle="collapse"][href="#${collapseId}"], [data-bs-toggle="collapse"][data-bs-target="#${collapseId}"]`);

				if ($collapseButton.length) {
					if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
						const collapse = new bootstrap.Collapse($collapse[0], { toggle: true });
					} else {
						$collapse.collapse('show');
					}

					// Aguarda transição do accordion antes de focar
					setTimeout(() => $firstInvalid.trigger('focus'), 350);
					return;
				}
			}

			// 3. Procura por modal que contenha o campo
			const $modal = $firstInvalid.closest('.modal');
			if ($modal.length && !$modal.hasClass('show')) {
				if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
					const modal = new bootstrap.Modal($modal[0]);
					modal.show();
				} else {
					$modal.modal('show');
				}

				// Aguarda modal abrir antes de focar
				setTimeout(() => $firstInvalid.trigger('focus'), 500);
				return;
			}

			// 4. Procura por lb-popup
			const $popup = $firstInvalid.closest('[data-lb-popup]');
			if ($popup.length && !$popup.hasClass('is-open')) {
				if (typeof window.lbPopup !== 'undefined' && window.lbPopup.open) {
					window.lbPopup.open($popup[0]);
				} else {
					$popup.addClass('is-open').removeAttr('aria-hidden');
				}

				setTimeout(() => $firstInvalid.trigger('focus'), 500);
				return;
			}

			// 5. Procura por elementos pais com display:none ou visibility:hidden
			const $hiddenParents = $firstInvalid.parents().filter(function () {
				const $el = $(this);
				return $el.css('display') === 'none' || $el.css('visibility') === 'hidden' || $el.hasClass('d-none') || $el.hasClass('hidden');
			});

			if ($hiddenParents.length) {
				$hiddenParents.each(function () {
					const $parent = $(this);
					$parent.removeClass('d-none hidden');
					if ($parent.css('display') === 'none') $parent.css('display', '');
					if ($parent.css('visibility') === 'hidden') $parent.css('visibility', '');
				});

				// Verifica se agora está visível
				setTimeout(() => {
					if ($firstInvalid.is(':visible')) {
						$firstInvalid.trigger('focus');
					} else {
						showMessage('w', 'Há campos obrigatórios não preenchidos. Verifique todas as seções do formulário.');
					}
				}, 100);
				return;
			}

			// 6. Se nenhuma estratégia funcionou, exibe mensagem
			showMessage('w', 'Há campos obrigatórios não preenchidos. Verifique todas as seções do formulário.');

			// Tenta scroll até o formulário pelo menos
			$form[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
		}

		// ============================================================================
		// SEÇÃO 6: EVENT LISTENERS E CONTROLE DE FLUXO
		// ============================================================================
		// Gerencia os eventos DOM e o fluxo de confirmação antes do AJAX

		/**
		 * Inicializa o atributo novalidate em forms com lbform
		 * Também observa o DOM para aplicar em formulários adicionados dinamicamente
		 */
		function initializeFormValidation($forms) {
			$forms.each(function () {
				const $form = $(this);

				// Aplica novalidate apenas se ainda não tiver
				if (!$form.attr('novalidate')) {
					$form.attr('novalidate', 'novalidate');
				}
			});
		}

		/**
		 * Configuração inicial: aplica novalidate em forms existentes
		 */
		$(document).ready(function () {
			initializeFormValidation($('[lbform]'));

			// MutationObserver para detectar formulários adicionados dinamicamente
			if (typeof MutationObserver !== 'undefined') {
				const observer = new MutationObserver(function (mutations) {
					mutations.forEach(function (mutation) {
						// Verifica se novos nós foram adicionados
						if (mutation.addedNodes.length > 0) {
							mutation.addedNodes.forEach(function (node) {
								// Ignora nós que não são elementos
								if (node.nodeType !== 1) return;

								const $node = $(node);

								// Verifica se o nó adicionado é um form com lbform
								if ($node.is('[lbform]')) {
									initializeFormValidation($node);
									cleanupFormState($node);
								}

								// Verifica se há forms com lbform dentro do nó adicionado
								const $forms = $node.find('[lbform]');
								if ($forms.length > 0) {
									initializeFormValidation($forms);
									$forms.each(function () {
										cleanupFormState($(this));
									});
								}
							});
						}

						// Verifica se nós foram removidos (cleanup)
						if (mutation.removedNodes.length > 0) {
							mutation.removedNodes.forEach(function (node) {
								// Ignora nós que não são elementos
								if (node.nodeType !== 1) return;

								const $node = $(node);

								// Verifica se o nó removido é um form com lbform
								if ($node.is('[lbform]')) {
									cleanupFormState($node);
								}

								// Verifica se há forms com lbform dentro do nó removido
								const $forms = $node.find('[lbform]');
								if ($forms.length > 0) {
									$forms.each(function () {
										cleanupFormState($(this));
									});
								}
							});
						}
					});
				});

				// Observa mudanças no body
				observer.observe(document.body, {
					childList: true,
					subtree: true
				});
			}
		});

		/**
		 * Limpa estados e dados de formulários para evitar problemas com reuso
		 * Remove flags de processamento, timers e dados anexados ao elemento
		 * @param {jQuery} $form - Elemento do formulário a ser limpo
		 */
		function cleanupFormState($form) {
			if (!$form || !$form.length) return;

			// Remove flag de processamento
			$form.removeData('lbform-processing');

			// Cancela timers de animação de texto
			const animationTimers = $form.data('lbform-animation-timers');
			if (animationTimers && Array.isArray(animationTimers)) {
				animationTimers.forEach(function (timerId) {
					clearTimeout(timerId);
				});
				$form.removeData('lbform-animation-timers');
			}

			// Remove classes de estado
			$form.removeClass('lb-disabled was-validated');

			// Remove classes de validação dos inputs
			$form.find('.is-invalid, .is-valid').removeClass('is-invalid is-valid');

			// Habilita inputs se estavam desabilitados
			$form.find(':input[disabled]').each(function () {
				const $input = $(this);
				// Só habilita se foi desabilitado pelo lbform (verifica se não tinha disabled original)
				if (!$input.data('lbform-original-disabled')) {
					$input.prop('disabled', false);
				}
			});
		}

		/**
		 * Event listener principal para interceptar submissão de formulários
		 * Usa delegação de eventos no document para capturar forms dinâmicos
		 * Intercepta todos os forms com atributo [lbform] e processa via AJAX
		 */
		$(document).on("submit", "[lbform]", function (evt) {
			// Previne submissão padrão do formulário
			evt.preventDefault();
			evt.stopPropagation();

			const formElement = this;
			const $form = $(formElement);

			// Ignora forms desabilitados ou em processamento
			if ($form.hasClass("lb-disabled") || $form.attr("disabled")) return;

			// Proteção contra submissões duplicadas usando $.data()
			if ($form.data('lbform-processing')) return;

			// Marca formulário como em processamento
			$form.data('lbform-processing', true);

			// IMPORTANTE: Validação customizada que tenta exibir campos invisíveis inválidos
			// Evita o erro "An invalid form control is not focusable" ao usar novalidate
			let hasInvalidVisibleFields = false;
			let hasInvalidInvisibleFields = false;
			let firstInvalidVisibleField = null;
			let firstInvalidInvisibleField = null;

			// Reseleciona os campos do DOM atual (importante após AJAX)
			const $requiredInputs = $(formElement).find(':input[required]');

			$requiredInputs.each(function () {
				const $input = $(this);
				const input = this;

				// Verifica validade do campo
				const isValid = input.checkValidity ? input.checkValidity() : true;

				if (!isValid) {
					if ($input.is(':visible')) {
						// Campo visível e inválido
						hasInvalidVisibleFields = true;
						if (!firstInvalidVisibleField) firstInvalidVisibleField = input;
					} else {
						// Campo invisível e inválido - precisa ser exibido
						hasInvalidInvisibleFields = true;
						if (!firstInvalidInvisibleField) firstInvalidInvisibleField = input;
					}

					// Mostra feedback de validação se existir
					$input.parents('.lbfield').find('.invalid-feedback').show();
				}
			});

			// Se há campos invisíveis inválidos, tenta exibi-los primeiro
			if (hasInvalidInvisibleFields) {
				$(formElement).addClass('was-validated');
				showInvalidHiddenElements(formElement);
				$form.data('lbform-processing', false);
				return;
			}

			// Se há campos visíveis inválidos, exibe erro e para
			if (hasInvalidVisibleFields) {
				$(formElement).addClass('was-validated');
				if (firstInvalidVisibleField) $(firstInvalidVisibleField).trigger('focus');
				$form.data('lbform-processing', false);
				return;
			}

			// === VALIDAÇÃO DE CAMPOS ESPECIAIS (.lbfield com hidden required) ===
			// Campos como draw_box, media_box possuem input hidden com required
			// Browsers não validam hidden inputs, então fazemos validação manual
			let hasInvalidSpecialFields = false;
			const $lbfields = $(formElement).find('.lbfield');

			$lbfields.each(function () {
				const $lbfield = $(this);
				// Busca input hidden com required (draw_box, media_box, etc)
				const $hiddenInput = $lbfield.find('input[type="hidden"][required]');

				if ($hiddenInput.length > 0) {
					const inputValue = $hiddenInput.val();
					const isEmpty = !inputValue || inputValue.trim() === '';

					if (isEmpty) {
						hasInvalidSpecialFields = true;
						$lbfield.addClass('is-invalid');

						// Destaque único da plataforma (borda + mensagem em cima dela);
						// só o primeiro rola até a tela.
						if (window.lbDestacarCampo) {
							const texto = $lbfield.find('.invalid-feedback').first().text().trim() || 'Preencha este campo.';
							window.lbDestacarCampo($lbfield[0], texto, { rolar: !firstInvalidVisibleField, focar: false });
						} else {
							$lbfield.find('.invalid-feedback').show();
						}
						if (!firstInvalidVisibleField) {
							firstInvalidVisibleField = $lbfield[0];
						}
					} else {
						// Campo válido - esconde feedback
						$lbfield.find('.invalid-feedback').hide();
						$lbfield.removeClass('is-invalid');
					}
				}
			});

			if (hasInvalidSpecialFields) {
				$(formElement).addClass('was-validated');
				$form.data('lbform-processing', false);
				return;
			}

			// Verifica se precisa de confirmação antes de prosseguir
			const configs = getConfigs(formElement);
			if (configs.confirm) {
				// Exibe popup de confirmação e só executa AJAX se confirmado
				confirmPopup(formElement,
					() => lbForm(formElement),
					() => $form.data('lbform-processing', false)
				);
			} else {
				// Executa AJAX diretamente sem confirmação
				lbForm(formElement);
			}
		});

		/**
		 * Sistema de confirmação com lbAlert (mascote)
		 * Exibe popup de confirmação antes de executar ação crítica
		 * 
		 * @param {HTMLFormElement} formElement - Elemento form a ser processado
		 * @param {Function} confirmedAction - Função a executar se confirmado
		 * @param {Function} recusedAction - Função a executar se cancelado
		 */
		function confirmPopup(formElement, confirmedAction, recusedAction = () => { }) {
			const configs = getConfigs(formElement);
			const {
				confirmTitle: title,
				confirmText: text,
				confirmColor: color,
				confirmButtonText: confirmText,
				confirmShowCancelButton: showCancelButton,
				confirmCancelButtonText: cancelText
			} = configs;

			// Map Swal-style colors to mascote codes
			const colorMap = { red: 'd', danger: 'd', green: 's', success: 's', blue: 'b', info: 'b', yellow: 'w', warning: 'w', purple: 'p', orange: 'w', gray: 'g' };
			const mascoteColor = colorMap[color] || color || 'w';

			lbAlert.confirm({
				title: title,
				text: text,
				color: mascoteColor,
				confirmButtonText: confirmText,
				cancelButtonText: cancelText || 'Cancelar',
				showCancelButton: showCancelButton,
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					confirmedAction();
				} else {
					recusedAction();
				}
			});
		}

		// ============================================================================
		// SEÇÃO 7: FUNÇÃO PRINCIPAL LBFORM - CORE DO SISTEMA AJAX
		// ============================================================================
		// Função principal que executa toda a lógica AJAX: validação, loader,
		// requisição, processamento de resposta e cleanup

		/**
		 * Função principal do sistema lbForm
		 * Executa todo o fluxo AJAX: validação, setup de loader, requisição,
		 * processamento de resposta, manipulação de DOM e cleanup final
		 * 
		 * @param {HTMLFormElement} form - Elemento form a ser processado via AJAX
		 */
		function lbForm(form) {
			const cfg = getConfigs(form);
			const $form = $(form);

			debug('lbForm started', { url: cfg.wpAjax ? lb_data.ajax_url : $(form).attr('data-action'), target: cfg.target });

			// Resolve URL (WP ajax ou action do form)
			const url = cfg.wpAjax ? lb_data.ajax_url : $(form).attr("data-action");
			if (!url) return console.error('lbForm: URL ausente');

			// Prepara FormData
			const formData = new FormData(form);
			appendAdditionalInputs(formData, form, cfg.additionalInputs);

			// Estado inicial: desabilita e bloqueia
			if (cfg.disableInputsOnSubmit) toggleFormInputs(form, true);
			toggleOtherForms(cfg.blockOthersForms, true);

			// Loader modes
			const target = cfg.target;
			let originalContent = null;
			let overlayEl = null;
			let buttonEl = null;
			let originalBtnHtml = null;
			let size = null;
			let $loaderEl = null;

			if (cfg.load === "page") {
				// Overlay global (não substitui conteúdo do target)
				overlayEl = $(buildLoader("page", cfg.loadText, null));
				overlayEl.hide().appendTo("body").fadeIn(300, function () {
					if (Array.isArray(cfg.loadText) && cfg.loadText.length > 1) {
						const $textEl = overlayEl.find('.lbf-load-text, .lb-carr-t');
						if ($textEl.length) {
							startTextAnimation(overlayEl[0], cfg.loadText, cfg.loadTextTiming || 2000, form);
						}
					}
				});
				$loaderEl = overlayEl;

				// Guarda referência ao conteúdo original para uso posterior
				if (target) {
					originalContent = { elements: $(target).children(), position: $(target).css('position') };
				}

			} else if (target) {
				size = getTargetSize(target);
				const $target = $(target);

				// Esconde conteúdo original sem remover
				const $originalContent = $target.children();
				$originalContent.hide();

				// Garante que target tenha posição relativa para loader absoluto
				const originalPosition = $target.css('position');
				if (originalPosition === 'static') {
					$target.css('position', 'relative');
				}

				// Adiciona loader mantendo altura do target
				const mode = cfg.load === "inline" ? "inline" : "target";
				const $loader = $(buildLoader(mode, cfg.loadText, null));//desativando size por enquanto
				$loader.hide().appendTo($target).fadeIn(300, function () {
					if (Array.isArray(cfg.loadText) && cfg.loadText.length > 1) {
						startTextAnimation($loader[0], cfg.loadText, cfg.loadTextTiming || 2000, form);
					}
				});

				$loaderEl = $loader;
				// Guarda referência ao conteúdo original para uso posterior
				originalContent = { elements: $originalContent, position: originalPosition };
			} else {
				// Sem target: anima botão de submit e prepara para detectar conteúdo automaticamente
				buttonEl = $(form).find('[type="submit"]').first();
				if (buttonEl.length && buttonEl.is('[data-lb-salvar]')) {
					// Barra de salvar (Barra_Salvar): o próprio botão mostra
					// "Salvando…"/"Salvo" — só avisa o formulário.
					form.dispatchEvent(new CustomEvent('lbform:enviando', { bubbles: true }));
					buttonEl = null;
				} else if (buttonEl.length) {
					originalBtnHtml = buttonEl.html();
					buttonEl.addClass("lbf-btn-loading");
					buttonEl.fadeOut(200, function () {
						buttonEl.html(buildLoader("inline", cfg.loadText, null)).fadeIn(300, function () {
							if (Array.isArray(cfg.loadText) && cfg.loadText.length > 1) {
								startTextAnimation(buttonEl[0], cfg.loadText, cfg.loadTextTiming || 2000, form);
							}
						});
						$loaderEl = buttonEl.find('.lbf-load-inline');
					});
				}
			}

			// Avisa o componente console (lbConsole/lbActionPlan) que uma requisição
			// começou — deixa o painel visível/com spinner mesmo na 1ª execução
			// (antes de existir qualquer linha, x-show="lines.length" ainda esconderia
			// o painel e, com ele, o loader nativo acima).
			if (target) {
				const targetEl = document.querySelector(target);
				if (targetEl) {
					targetEl.dispatchEvent(new CustomEvent('lbform:loading', { bubbles: true }));
				}
			}

			$.ajax({
				type: form.dataset.method || form.method || "POST",
				url,
				processData: false,
				contentType: false,
				data: formData,
				// dataType removido para permitir detecção automática pelo jQuery
				xhrFields: { withCredentials: true },
				headers: (function () {
					const h = {};
					try {
						if (url && url.indexOf(lb_data.rest_url) === 0 && lb_data.rest_nonce) {
							// Autentica chamadas REST com cookie + nonce
							h['X-WP-Nonce'] = lb_data.rest_nonce;
						}
					} catch (_) { }
					return h;
				})(),
				success: function (response) {
					debug('Response (success)', response);

					// Verifica se é uma resposta de erro do WordPress (wp_send_json_error)
					// WordPress retorna HTTP 200 com {success: false} no JSON
					if (response && response.success === false) {
						// WordPress error (success: false) - redirect to error handler
						const fakeError = {
							responseJSON: response,
							responseText: JSON.stringify(response),
							status: 200,
							statusText: 'OK'
						};

						// Chama o handler de erro manualmente
						this.error(fakeError, 'success-false');
						return;
					}

					const merged = getResponseConfigs(response?.lbform ?? response?.data?.lbform ?? {}, cfg);
					// Redirect / refresh full (toast será perdido no reload — sai antes)
					if (merged.redirect || merged.refresh) {
						applyRedirectOrRefresh(merged.redirect, merged.refresh, false);
						return;
					}
					updateHistory(merged.newUrl, merged.newUrlTitle);

					// Ações administrativas novas (Action_Output): resposta é JSON
					// estruturado {console,html,counters,plan} — acumula no painel
					// lbConsole (CustomEvent) em vez de substituir o target inteiro.
					if (merged.consoleAppend) {
						const payload = response?.data ?? {};
						if (target) {
							const $target = $(target);
							const targetEl = $target.get(0);
							const dispatchConsoleEvent = () => {
								if (originalContent?.elements) originalContent.elements.fadeIn(300);
								if (targetEl) {
									targetEl.dispatchEvent(new CustomEvent('lbform:console', {
										bubbles: true,
										detail: {
											lines: payload.console || [],
											html: payload.html || '',
											counters: payload.counters || {},
											plan: payload.plan || null,
										},
									}));
								}
							};
							if ($loaderEl) {
								restoreTargetContent($loaderEl, $target, originalContent, dispatchConsoleEvent);
							} else {
								// Sem loader ativo no momento da resposta (não deveria
								// acontecer pro fluxo normal, mas sem isso o evento nunca
								// dispara e o card nunca atualiza — some silenciosamente
								// atrás do toast nativo, sem erro nenhum no console).
								dispatchConsoleEvent();
							}
						}
						if (overlayEl) {
							overlayEl.fadeOut(300, function () { overlayEl.remove(); });
						}
						if (!cfg.silence) {
							playSafe(sounds.success);
						}
						replace(merged?.replace ?? {});
						maybeUpdateFormAttr(form, merged?.lbformNew);
						if (merged.closeModal) {
							closeAllModals();
						}
						if (merged.nextForm) {
							const next = $(merged.nextForm).get(0);
							if (next) {
								if (!cfg.silence) {
									playSafe(sounds.success);
								}
								lbForm(next);
							}
						}
						if (merged.isLastForm) {
							if (!cfg.silence) {
								playSafe(sounds.chainSuccess);
							}
							if (!merged.noToasts) {
								showMessage("s", merged.isLastForm);
							}
						}
						return;
					}

					const html = extractHtml(response);
					const $html = $("<div>").html(html);

					// Contador de mensagens processadas.
					let messagesLength = 0;

					// Processa mensagens ANTES de verificar se HTML está vazio
					if (!merged.noToasts) {
						messagesLength = handleMessagesHtml($html, response, true);
					}

					// Obtém HTML final após processamento de mensagens
					let finalHtml = $html.html();

					// Processa mensagens do json.
					if (messagesLength === 0 && isJsonResponse(response)) {
						if (!merged.noToasts) {
							messagesLength = handleMessagesJson(response, true);
						}
					}

					// Se nenhuma mensagem foi exibida, exibe mensagem padrão de sucesso
					if (messagesLength === 0 && !merged.noToasts) {
						showMessage('s', cfg.messageSuccess);
					}

					// Toca som de sucesso se não estiver silenciado
					if (!merged.silence) {
						playSafe(sounds.success);
					}

					// htmx refresh parcial — toast sobrevive ao swap (#lb-alert-container fora de #lb_body)
					if (merged.refresh_htmx) {
						applyRedirectOrRefresh(false, false, merged.refresh_htmx);
						return;
					}
					// Função para processar resposta após animação de texto finalizar
					const processResponse = () => {
						if (target) {
							const $target = $(target);
							if ($loaderEl) {
								restoreTargetContent($loaderEl, $target, originalContent, () => {
									if (finalHtml && String(finalHtml).trim() !== "") {
										if (originalContent?.elements) originalContent.elements.remove();
										$target.html(finalHtml).hide();
										initDynamicContent($target);
										$target.fadeIn(300);
									} else if (merged.removeOnEmpty) {
										$target.fadeOut(300, function () { $target.remove(); });
									} else if (originalContent?.elements) {
										originalContent.elements.fadeIn(300);
									}
								});
							}
						} else if (finalHtml && String(finalHtml).trim() !== "") {
							const $container = findBestContainer();

							// Remove conteúdo anterior com classe lbf-body-content se existir
							//$container.find('.lbf-body-content').remove();

							// Adiciona novo conteúdo usando método seguro
							const $content = $('<div class="lbf-body-content">').html(finalHtml).hide();
							$container.append($content);
							initDynamicContent($content);
							$content.fadeIn(300);
						}

						// Remove overlay global após processar conteúdo
						if (overlayEl) {
							overlayEl.fadeOut(300, function () { overlayEl.remove(); });
						}
					};

					// Verifica se há animação de texto em andamento
					// Para load page: usa overlayEl, para target: usa $loaderEl
					let $animationEl = null;
					if (cfg.load === "page" && overlayEl) {
						$animationEl = overlayEl;
					} else if ($loaderEl) {
						$animationEl = $loaderEl;
					}

					if ($animationEl && Array.isArray(cfg.loadText) && cfg.loadText.length > 1) {
						const showFinalText = $animationEl.data('showFinalText');
						if (showFinalText && typeof showFinalText === 'function') {
							// Chama última mensagem e aguarda o tempo definido
							showFinalText();

							// Processa resposta após animação finalizar
							setTimeout(processResponse, lastLoadTime + 200); // 200ms extra para garantir lastLoadTime + 200
						} else {
							// Não há animação, processa imediatamente
							processResponse();
						}
					} else {
						// Não há array de texto, processa imediatamente
						processResponse();
					}

					// Foco no primeiro input visível — não em tela de toque (abriria
					// o teclado), a não ser que o form peça data-lb-autofocus="sempre".
					const toque = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
					if (!toque || 'sempre' === $(form).closest('[data-lb-autofocus]').attr('data-lb-autofocus')) {
						const $firstInput = $("input:visible:enabled:first", form);
						if ($firstInput.length) $firstInput.focus();
					}

					replace(merged?.replace ?? {});
					//openAjaxModals();
					maybeUpdateFormAttr(form, merged?.lbformNew);

					// Fecha modais se configurado
					if (merged.closeModal) {
						closeAllModals();
					}

					if (merged.nextForm) {
						const next = $(merged.nextForm).get(0);
						if (next) {
							if (!cfg.silence) {
								playSafe(sounds.success);
							}
							lbForm(next);
						}
					}
					if (merged.isLastForm) {
						if (!cfg.silence) {
							playSafe(sounds.chainSuccess);
						}
						if (!cfg.noToasts) {
							showMessage("s", merged.isLastForm);
						}
					}
				},
				error: function (jqXHR, textStatus) {
					debug('Response (error)', { status: jqXHR?.status, textStatus });

					// Remove loader com animação
					if (overlayEl) {
						overlayEl.fadeOut(300, function () { overlayEl.remove(); });
					}

					// Tenta montar objeto da resposta de erro
					const respObj =
						jqXHR?.responseJSON ||
						(function () {
							try {
								return JSON.parse(jqXHR?.responseText || "{}");
							} catch (_) {
								return {};
							}
						})();

					// Sessão vencida: aviso + volta ao login com redirect_to, em vez
					// do toast técnico de nonce/cookie. Ver session-expired.js.
					if (window.lbSession && window.lbSession.handle(jqXHR?.status, respObj)) {
						return;
					}

					// O servidor disse qual campo está errado (data.campo/field): destaca ele.
					if (window.lbDestacarErroServidor) window.lbDestacarErroServidor(respObj, form);

					const merged = getResponseConfigs(respObj?.lbform || {}, cfg);

					// Ações administrativas novas (consoleAppend): mesmo em erro de
					// transporte, injeta uma linha de erro no console em vez de
					// substituir o HTML do target (que quebraria o componente Alpine).
					if (merged.consoleAppend) {
						if (target) {
							const $target = $(target);
							const targetEl = $target.get(0);
							const dispatchErrorEvent = () => {
								if (originalContent?.elements) originalContent.elements.fadeIn(300);
								if (targetEl) {
									const errorText = (respObj && typeof respObj.data === 'string' && respObj.data)
										|| (respObj && respObj.data && respObj.data.message)
										|| cfg.messageError;
									targetEl.dispatchEvent(new CustomEvent('lbform:console', {
										bubbles: true,
										detail: {
											lines: [{ level: 'error', text: errorText, ts: Date.now() / 1000 }],
											html: '',
											counters: {},
										},
									}));
								}
							};
							if ($loaderEl) {
								restoreTargetContent($loaderEl, $target, originalContent, dispatchErrorEvent);
							} else {
								dispatchErrorEvent();
							}
						}
						playSafe(sounds.error);
						return;
					}

					const html = extractHtml(respObj || jqXHR?.responseText || "");
					const $html = $("<div>").html(html);

					// Contador de mensagens processadas.
					let messagesLength = 0;

					// Processa mensagens ANTES de verificar se HTML está vazio
					//if (!merged.noToasts) {
					messagesLength = handleMessagesHtml($html, respObj, false);
					//}

					// Obtém HTML final após processamento de mensagens
					let finalHtml = $html.html();

					// Processa mensagens do json.
					if (messagesLength === 0 && isJsonResponse(jqXHR)) {
						messagesLength = handleMessagesJson(respObj, false);
					}

					// Se nenhuma mensagem foi exibida, exibe mensagem padrão de erro
					if (messagesLength === 0) {
						showMessage('d', cfg.messageError);
					}

					// Toca som de erro se não estiver silenciado
					//if (!merged.silence) {
					playSafe(sounds.error);
					//}
					// Processa target seguindo a mesma lógica do success
					if (target && $loaderEl) {
						const $target = $(target);
						restoreTargetContent($loaderEl, $target, originalContent, () => {
							// Decide o que mostrar após erro - igual ao success
							if (finalHtml && String(finalHtml).trim() !== "") {
								// Remove conteúdo original e substitui por HTML de erro
								if (originalContent && originalContent.elements) {
									originalContent.elements.remove();
								}

								// Cria elemento de forma segura para evitar erro de parsing
								const $newContent = $('<div>').html(finalHtml).children().first();
								if ($newContent.length === 0) {
									// Se não há elemento filho, usa o HTML diretamente
									$target.html(finalHtml);
									initDynamicContent($target);
								} else {
									$newContent.hide();
									$target.append($newContent);
									initDynamicContent($target);
									$newContent.fadeIn(300);
								}

							} else if (merged.removeOnEmpty) {
								// Remove target completamente se resposta vazia
								$target.fadeOut(300, function () { $target.remove(); });
							} else {
								// Só restaura conteúdo original se não há HTML de erro
								if (originalContent && originalContent.elements) {
									originalContent.elements.fadeIn(300);
								}
							}
						});
					} else if (finalHtml && String(finalHtml).trim() !== "") {
						const $container = findBestContainer();

						// Adiciona conteúdo de erro usando método seguro
						const $content = $('<div class="lbf-body-content lbf-error-content">').html(finalHtml).hide();
						$container.append($content);
						initDynamicContent($content);
						$content.fadeIn(300);
					}
				},
				complete: function (xhr, status) {
					$form.data('lbform-processing', false);
					restoreForm(form);

					// Barra de salvar: termina o "Salvando…" (ok = sem erro HTTP nem success:false).
					const json = xhr && xhr.responseJSON;
					form.dispatchEvent(new CustomEvent('lbform:terminou', {
						bubbles: true,
						detail: { ok: status === 'success' && !(json && json.success === false) },
					}));
					toggleOtherForms(cfg.blockOthersForms, false);

					if (cfg.disableModeFocus && $("body").attr("data-layout") === "lb-focus") {
						$("body").removeAttr("data-layout");
					}

					// Remove overlay global e restaura botão com animação
					// Só remove o overlay se não houver animação de texto aguardando
					const hasTextAnimation = overlayEl && Array.isArray(cfg.loadText) && cfg.loadText.length > 1;
					if (overlayEl && !hasTextAnimation) {
						try {
							if (overlayEl.is(':visible')) {
								overlayEl.fadeOut(300, function () { overlayEl.remove(); });
							} else {
								overlayEl.remove();
							}
						} catch (_) { }
					}

					if (buttonEl && originalBtnHtml != null) {
						buttonEl.fadeOut(200, function () {
							buttonEl.removeClass("lbf-btn-loading").html(originalBtnHtml).fadeIn(300);
						});
					}

					// Cancela timers de animação restantes
					if ($loaderEl) {
						const cancelAnimation = $loaderEl.data('cancelAnimation');
						if (cancelAnimation && typeof cancelAnimation === 'function') {
							cancelAnimation();
						}
					}

					// Dispara evento global lbAjaxComplete após breve atraso
					setTimeout(() => {
						const detail = { target, formData };
						document.dispatchEvent(new CustomEvent("lbAjaxComplete", { detail }));
						$(document).trigger("lbAjaxComplete", [detail]);
					}, 800);

				},
			});
		}

		// Sistema lbform inicializado

	});
})(jQuery);
